module.exports = __webpack_public_path__ + "static/media/41.f86023b2.JPG";